import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { PortalPage } from './pages/Portal';
import { CustomerSelectPage } from './pages/CustomerSelect';
import { AuditDashboardPage } from './pages/AuditDashboard';
import { AdminLoginPage } from './pages/admin/AdminLogin';
import { AdminCustomersPage } from './pages/admin/AdminCustomers';
import { AdminCustomerNewPage } from './pages/admin/AdminCustomerNew';
import { AdminCustomerEditPage } from './pages/admin/AdminCustomerEdit';
import { AdminCustomerAuditPage } from './pages/admin/AdminCustomerAudit';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {/* Both the audit dashboard and the customer-picker landing live at
            static paths so they take precedence over the /portal/* splat
            that owns the file viewer. React Router picks the static match
            regardless of declaration order. */}
        <Route path="/portal/select" element={<CustomerSelectPage />} />
        <Route path="/portal/audit" element={<AuditDashboardPage />} />
        <Route path="/portal/*" element={<PortalPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminCustomersPage />} />
        <Route path="/admin/customers/new" element={<AdminCustomerNewPage />} />
        <Route path="/admin/customers/:id" element={<AdminCustomerEditPage />} />
        <Route path="/admin/customers/:id/audit" element={<AdminCustomerAuditPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
